import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaRegFileLines } from 'react-icons/fa6';
import SalaryAdjustments from "./index";
import ViewSalaryAdjustment from "./view";
import EditSalaryAdjustment from "./edit";
import { MODULE_SAL_ADJUSTMENTS } from "variables/constants";

const salaryAdjustmentRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Salary Adjustments",
		basePath: "salary-adjustments",
		mainComponent: <SalaryAdjustments />,
	    layout: "/console",	   
	    icon: <FaRegFileLines className="icon-item" />,
	    subTitle:"Salary Adjustment",
	    viewComponent: <ViewSalaryAdjustment />,
	    createComponent: <EditSalaryAdjustment />,
	    editComponent: <EditSalaryAdjustment />,
		level:3,
		moduleId: MODULE_SAL_ADJUSTMENTS,
	})
]

export default salaryAdjustmentRoutes;